import * as React from 'react';

export function SvgXLogo(props: any) {
  return (
    <svg
      {...props}
      viewBox="-2 -2 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1881 10.1624L22.7504 0H20.7214L13.2868 8.82384L7.34879 0H0.5L9.47943 13.3432L0.5 24H2.5291L10.3802 14.6817L16.6512 24H23.5L14.1876 10.1624H14.1881ZM11.409 13.4608L10.4992 12.1321L3.26021 1.55962H6.37679L12.2187 10.0919L13.1285 11.4206L20.7224 22.5113H17.6058L11.409 13.4613V13.4608Z"
        fill="#292A2E"
      />
    </svg>
  );
}
